import { inject, Injectable } from '@angular/core';
import { map, Observable, throwError } from 'rxjs';
import { Nullable } from '@pin-up-global/common';
import { ORIGIN_TRANSPORT } from '@shared/grpc-transport/transport-tokens';
import { SimpleAuthService } from '@grpc-gen/admin-auth-main/pinup/google_auth/simple/service_pb';
import {
  UIPermissionsSchema,
} from '@grpc-gen/admin-auth-main/pinup/google_auth/any_field_resources/ui_permissions_pb';
import { fromBinary } from '@bufbuild/protobuf';
import { AccessData } from './auth.abstraction';

const MOCK_PERMISSIONS_FOR_MVP = [
  'AddNewBot',
  'BotSettingsPage',
  'UsersPage',
  'UserDetails',
  'BlockUser',
  'ArchiveCampaign',
  'ArchiveFeedback',
  'FlowEditorPage',
  'AnalyticsPage',
  'AnalyticsExport',
  'CampaignsPage',
  'FeedbacksPage',
];

@Injectable({
  providedIn: 'root',
})
export class AuthGrpcApiService {
  #transport = inject(ORIGIN_TRANSPORT);

  refresh(token: Nullable<string>): Observable<Omit<AccessData, 'refresh'>> {
    if (!token) {
      return throwError(() => new Error('No refresh token'));
    }

    return this.#transport.summon(SimpleAuthService, 'refreshToken', { refresh: token }).pipe(
        map(data => {
          const permissions = this.decodePermissions(data.extras);
          return { access: data.access, permissions } as unknown as Omit<AccessData, 'refresh'>;
        }),
    );
  }

  signIn(token: string): Observable<AccessData> {
    return this.#transport.summon(SimpleAuthService, 'signIn', { token }).pipe(
      map(data => {
        const permissions = this.decodePermissions(data.extras);
        return {
          access: data.access,
          refresh: data.refresh,
          permissions,
        } as unknown as AccessData;
      }),
    );
  }

  decodePermissions(extras: any[]): string[] {
    return MOCK_PERMISSIONS_FOR_MVP;
    // try {
    //   const binary = extras[0].value;
    //   const permissions = fromBinary(UIPermissionsSchema, binary);
    //   return permissions.permission;
    // } catch {
    //   return [];
    // }
  }
}
